import { getStore } from '~/mobx/AppStore';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { isEmpty } from 'lodash';
import { FORM_FIELDS } from '~/consts/admin';
import { ELECTION_ATTRIBUTE_NUMBERS } from '~/consts/elections';

const showValidationErrors = (errors: Record<string, boolean>) => {
    const errorMessageContent = (
        <div className="items-center flex flex-col">
            <div> Følgende felfer er feil </div>
            {Object.keys(errors).map((key) => {
                return <div key={key}>{FORM_FIELDS[key].label}</div>;
            })}

            <div>Klikk på teksten for å fjerne denne meldingen.</div>
        </div>
    );
    showMessageModal('error', errorMessageContent);
};

const validateField = (fieldKey: string): boolean => {
    const { regionStore, adminStore } = getStore();

    const attribute = adminStore.attributesState.find((a) => a.number === fieldKey);
    let value = attribute?.value;

    // Special case: Validate that the selected region exists in regionStore
    const isRegionField = fieldKey === ELECTION_ATTRIBUTE_NUMBERS['election_default_region'];
    if (isRegionField) {
        const regionExists = regionStore.regions.some((region) => region.id === value);
        if (!regionExists) {
            value = '';
        }
    }
    // Field is valid if it has a non-empty value
    return Boolean(value);
};

const getValidationErrors = (): Record<string, boolean> => {
    const errors: Record<string, boolean> = {};

    Object.keys(FORM_FIELDS).forEach((fieldKey) => {
        const config = FORM_FIELDS[fieldKey];
        if (config.required && !validateField(fieldKey)) {
            errors[fieldKey] = true;
        }
    });

    return errors;
};

export const validateForm = () => {
    const { adminStore } = getStore();

    const errors = getValidationErrors();
    adminStore.setValidationErrors(errors);

    // Set flag to show validation errors when validateForm is called during updateElection
    adminStore.setShouldShowValidationErrors(true);

    // Return true if form is invalid, otherwise false
    if (!isEmpty(errors)) {
        showValidationErrors(errors);
        return true;
    }
    return false;
};
